import {Brick, registerBrick, Service} from 'olympe';
import {SHARED_MEMORY_TOPICS} from '../../../services/service_api/CreateAllRASharedMemory.brick';

/**
 * This brick checks if a buyer cookie exists by interacting with shared memory.
 */
export default class BuyerCookieExists extends Brick {
    /**
     * @override
     * @protected
     * @param {!BrickContext} $
     * @param {string} buyerCookieId
     * @param {function()} forwardEvent
     * @param {function(boolean)} setExists
     */
    update($, [buyerCookieId], [forwardEvent, setExists]) {
        Service.get('allRaSharedMemory', {topic: SHARED_MEMORY_TOPICS.CXML_BUYER_COOKIE_EXISTS, buyerCookieId: buyerCookieId})
            .then((data) => {
                setExists(data.exists);
                forwardEvent();
            });
    }
}

registerBrick('0197c14783aa28da5429', BuyerCookieExists);
